import React, { useEffect } from "react";
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  Icon,
} from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../config/axiosInstance";


const SuccessPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (sessionId) {
      axiosInstance
        .post("/api/orders/mark-paid", { sessionId })
        .then(() => {
          console.log("Order marked as paid");
        })
        .catch((err) => {
          console.error("Failed to mark order as paid", err);
        });
    }
  }, []);

  return (
    <Box minH="80vh" bg="#F2EEE8" display="flex" alignItems="center" justifyContent="center">
      <VStack spacing={6} textAlign="center" maxW="md" bg="white" p={10} rounded="xl" shadow="md">
        <Icon as={CheckCircleIcon} w={12} h={12} color="green.500" />
        <Heading size="lg">Payment Successful</Heading>
        <Text>Your order has been placed successfully.</Text>
        <Button onClick={() => navigate("/order")} colorScheme="green" size="lg" rounded="md">
          View My Orders
        </Button>
        <Button onClick={() => navigate("/discover-all")} variant="outline" size="md">
          Continue Shopping
        </Button>
      </VStack>
    </Box>
  );
};

export default SuccessPage;
